import styled from 'styled-components'

import arrow_icon from '@/assets/main/main8/swiper-arrow.png'
import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const Main8SectionWrap = styled.div`
  width: 100%;
  margin: 0 auto;
  height: 1086px;
  text-align: center;
  display: block;
  background: ${COLOR.gray10};
  ${customMedia.lessThan('tablet')`
     height: 751px;
   `}
  > h3 {
    padding: 94px 0 64px 0;
    margin: 0;
    font-family: NanumSquareNeoExtraBold, sans-serif;
    font-size: 60px;
    line-height: 80px;
    ${customMedia.lessThan('tablet')`
     padding: 43px 0 38px 0;
   `}
  }

  > img {
    position: absolute;
    z-index: 10;
    left: 50%;
    transform: translateX(-50%);
    width: 324px;
    height: 630px;
    ${customMedia.lessThan('tablet')`
     width: 235px;
     height: 456px;
   `}
  }

  ${customMedia.lessThan('tablet')`
    >h3{
     font-size: 24px;
     line-height: 27px;
    }
    `}
`
const Main8SectionContent = styled.div`
  width: 100%;
  margin: 0 auto;
  max-width: 1920px;
  height: 754px;

  .swiper-button-prev,
  .swiper-button-next {
    cursor: pointer;
    display: flex;
    width: 60px;
    height: 60px;
    background-image: url(${arrow_icon});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    position: absolute;
    top: 36%;
    z-index: 10;

    &:hover,
    &:active {
      -webkit-tap-highlight-color: transparent;
    }
  }

  .swiper-button-prev {
    left: 0;
  }

  .swiper-button-next {
    right: 0;
    transform: rotate(180deg);
  }

  .swiper-slide {
    width: 321px;
    opacity: 0.5;
    ${customMedia.lessThan('tablet')`
     width: 256px;
   `}
    > div {
      > p,
      > span {
        display: none;
      }
    }

    &.swiper-slide-active {
      opacity: 1;

      > div {
        > p,
        > span {
          display: flex;
        }
      }
    }
  }
`
const Main8SectionItem = styled.div`
  width: 321px;
  margin: 0;
  height: 754px;
  display: block;
  ${customMedia.lessThan('tablet')`
     width: 256px;
     height: 600px;
   `}

  > img {
    width: 301px;
    ${customMedia.lessThan('tablet')`
     width: 215px;
     height: 446px;
   `}
  }

  > p {
    text-align: left;
    font-family: NanumSquareNeoExtraBold, sans-serif;
    font-size: 24px;
    line-height: 27px;
    margin: 46px 0 13px 0;

    > span {
      display: inline-block;
      width: 28px;
      height: 28px;
      color: ${COLOR.white};
      background: ${COLOR.point1};
      border-radius: 100px;
      font-family: NotoSansBold, sans-serif;
      font-size: 16px;
      text-align: center;
      margin-right: 10px;
      line-height: 28px;
    }
  }

  > span {
    float: right;
    text-align: left;
    display: inline-block;
    width: 280px;
    font-size: 16px;
    height: 69px;
    font-family: NotoSansRegular, sans-serif;
  }
  ${customMedia.lessThan('tablet')`
   >p{
    font-size: 18px;
    line-height: 20px;
    margin: 32px 0 13px 0;
    >span{
    font-size: 12px;
    line-height: 20px;
    width:20px;
    height:20px;
  
    }
   }
   >span{
     float: left;
     margin-left: 30px;
     width: 204px;
     font-size: 14px;
     line-height: 20px;
     }
    `}
`

export { Main8SectionContent, Main8SectionItem, Main8SectionWrap }
